module.exports = "/_next/static/images/46cbb19f331c17b5d6d40db54508a316-mulher-com-cachos-maravilhosos-segurando-cartao-lg@3x.jpg.webp";